'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdYoutubeSearchedFor = function MdYoutubeSearchedFor(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 23.4l8.2 8.2-2.4 2.5-8.3-8.3v-1.3l-0.5-0.4q-3 2.5-7 2.5-3 0-5.6-1.4l2.5-2.5q1.5 0.7 3.1 0.7 3.1 0 5.3-2.2t2.2-5.3-2.2-5.4-5.3-2.1-5.4 2.1-2.1 5.4h5.7l-6.8 6.6-6.4-6.6h4.1q0-4.5 3.2-7.7t7.7-3.2q4.5 0 7.7 3.2t3.1 7.7q0 3.9-2.6 7l0.4 0.5h1.4z' })
        )
    );
};

exports.default = MdYoutubeSearchedFor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/youtube-searched-for.js
// module id = 3476
// module chunks = 0